<template>
  <div class="footer center" :class="{'opacity':islogin}" style="justify-content: center;">
    <p>Copyright © 2018  西本新干线 &nbsp;&nbsp;  沪ICP12025672号-2 &nbsp;&nbsp; 沪公网安备 31010902001335号&nbsp;&nbsp;&nbsp;&nbsp;</p>
    <!-- <a href="http://sns.96369.net" target="_Blank">旧版OA</a> -->
    <!-- <p class="address">联系地址：上海市虹口区东体育会路990号西本新干线  联系电话：021-84150633 沪公网安备1101050203280</p> -->
  </div>
</template>
<script>
export default {
  props: {
    islogin: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "~common/stylus/variable"
.footer
  position: relative
  z-index: 88
  height: 80px
  background: rgba(35,47,61,1)
  color: $text-color-white
  font-size: $font-size-small
.footer.opacity
  background: rgba(35,47,61,.5)
.address
  margin-top: 10px
a
  color: #2d8cf0
  text-decoration: underline
</style>



// WEBPACK FOOTER //
// src/base/footer/footer.vue